var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 1.5C17.2932 1.5 17.9804 1.81424 18.5317 2.36987L21.6326 5.47077C22.1886 6.02679 22.5 6.70911 22.5 7.5C22.5 8.28578 22.191 9.10092 21.6326 9.65939L10.3353 20.9513C9.54991 21.8573 8.43657 22.4139 7.1346 22.5023H3H1.5V21.0023L1.50487 16.747C1.60047 15.5637 2.1506 14.4634 2.97294 13.7399L14.3414 2.37151C14.8993 1.81077 15.7131 1.5 16.5 1.5ZM5.02735 15.9241C4.71902 16.1968 4.52828 16.5783 4.5 16.8678V19.5037L7.02867 19.5061C7.43053 19.4776 7.8046 19.2906 8.14124 18.9081L14.714 12.3353L11.6663 9.28758L5.02735 15.9241ZM13.788 7.16664L16.8353 10.214L19.4842 7.56508L16.4374 4.51819L13.788 7.16664Z",
    fill: "#9A9AB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.2854deefcf8b2bc0fadb19cbd480caef.svg";
export { ForwardRef as ReactComponent };